import { useAppQuery } from 'core/query/hooks/useAppQuery';
import { AxiosResponse } from 'axios';
import { useMemo } from 'react';
import { getInfraRequestServicesApi } from 'TenantModule/api/getInfraRequestServicesApi';
import { InfraRequestServicesResponse } from 'TenantModule/types';
import { tenantQueryKeys } from './tenantQueryKeys';

/**
 * Tenant stack PR options (RDM-2277). `enabled` comes from the backend only — the
 * FE never decides party vs prod itself. Any failure (404 on an older backend,
 * 5xx, network) degrades to "disabled": the create form simply hides the infra
 * fields instead of erroring.
 */
export const useInfraRequestServicesQuery = () => {
  const query = useAppQuery<AxiosResponse<InfraRequestServicesResponse>>({
    queryKey: tenantQueryKeys.list({ identifier: 'useInfraRequestServicesQuery' }),
    queryFn: ({ token, buildConfig }) =>
      getInfraRequestServicesApi({ params: undefined, token, config: buildConfig() }),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  const { enabled, services } = useMemo(() => {
    const raw = query.data?.data;
    return {
      enabled: raw?.enabled === true,
      services: Array.isArray(raw?.services) ? raw.services : [],
    };
  }, [query.data?.data]);

  return {
    enabled: !query.isError && enabled,
    services: query.isError ? [] : services,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
